// src/components/charts/DeudaActivosCharts.jsx
import React, { useState, useEffect } from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import BarrasHorizontalesChart from './BarrasHorizontalesChart';
import kpiService from '../../services/kpiService';

/**
 * Componente para mostrar Deuda por área
 */
export const DeudaPorAreaChart = ({ fechaInicio, fechaFin, empresaId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await kpiService.getDeudaPorArea({
          fechaInicio,
          fechaFin,
          empresaId,
        });

        if (response.success) {
          setData(response.data);
        } else {
          throw new Error('No se pudieron cargar los datos');
        }
      } catch (err) {
        console.error('Error fetching deuda por área:', err);
        setError('Error al cargar el gráfico.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fechaInicio, fechaFin, empresaId]);

  if (error) return <Alert variant="danger">{error}</Alert>;
  
  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Cargando datos...</p>
      </div>
    );
  }

  return <BarrasHorizontalesChart title="Deuda por área" data={data} />;
};

/**
 * Componente para mostrar Activos por área
 */
export const ActivosPorAreaChart = ({ fechaInicio, fechaFin, empresaId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await kpiService.getActivosPorArea({
          fechaInicio,
          fechaFin,
          empresaId,
        });

        if (response.success) {
          setData(response.data);
        } else {
          throw new Error('No se pudieron cargar los datos');
        }
      } catch (err) {
        console.error('Error fetching activos por área:', err);
        setError('Error al cargar el gráfico.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fechaInicio, fechaFin, empresaId]);

  if (error) return <Alert variant="danger">{error}</Alert>;
  
  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Cargando datos...</p>
      </div>
    );
  }

  return <BarrasHorizontalesChart title="Activos por área" data={data} />;
};

/**
 * Componente para mostrar Principales Acreedores
 */
export const PrincipalesAcreedoresChart = ({ fechaInicio, fechaFin, empresaId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await kpiService.getPrincipalesAcreedores({
          fechaInicio,
          fechaFin,
          empresaId,
        });

        if (response.success) {
          // Transformar para usar el formato correcto
          const transformed = response.data.map(item => ({
            area: item.acreedor,
            porcentaje: item.porcentaje,
            color: item.color,
          }));
          setData(transformed);
        } else {
          throw new Error('No se pudieron cargar los datos');
        }
      } catch (err) {
        console.error('Error fetching principales acreedores:', err);
        setError('Error al cargar el gráfico.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [fechaInicio, fechaFin, empresaId]);

  if (error) return <Alert variant="danger">{error}</Alert>;
  
  if (loading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Cargando datos...</p>
      </div>
    );
  }

  return <BarrasHorizontalesChart title="Principales Acreedores" data={data} />;
};